import axios from 'axios'
import config from '../../config/local-config'
import apiConfig from '../../config/api-config'
import getAccessToken from './getAccessToken'

const getProxyOrderDetails = (opt, accessTokenObj, orderId, email) => {
  const version = 'v1.0'
  const serviceName = 'proxy-myaccount/Account'
  const apiKey = {
    headers: {
      apikey: apiConfig.apiKey,
    },
  }
  const iat = 'now'
  const domain = `${config.hydra.site}`
  const apiUrl = `${apiConfig.apiURL}/${serviceName}/${version}/index?`
  const body = {
    opt,
    domain,
    customer_id: accessTokenObj.customer_id,
    access_token: accessTokenObj.access_token,
    iat,
    order_id: orderId,
    email,
  }

  return axios.post(apiUrl, body, {
    ...apiKey,
  })
}

const getProxyOrder = async ({ orderId, emailAdd }) => {
  let opt = 'orderStatus'
  if (!emailAdd) opt = 'orderDetails'

  // eslint-disable-next-line no-return-await
  return await getAccessToken()
    .then(tokenData => getProxyOrderDetails(opt, tokenData, orderId, emailAdd))
    .then(({ data }) => (data && data.results && data.results.order) || [])
    .catch(error => {
      throw error
    })
}

export { getProxyOrder }
export default getProxyOrderDetails
